import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as Sentry from "@sentry/react";
import Avatar from "@material-ui/core/Avatar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { isFirefox } from "react-device-detect";
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import { FiSend } from "react-icons/fi";
import { BsArrowDown } from "react-icons/bs";
import { HiCurrencyRupee } from "react-icons/hi";
import { iconsDict } from "../../assets/icons/iconsDict.js";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import TabSearchbar from "../../components/TabSearchbar/index.js";
import Icon from "../../fontIcons/icon";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../services/configs";
import loaderGif from "../../assets/img/loader.gif";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher.js";
import { useQuery } from "react-query";
import CryptoWalletDialog from "../../components/CrytoWalletDialog/index.js";
function CryptoWallet() {
  const classes = useStyles();
  let history = useHistory();
  const theme = useTheme();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const token = useSelector((state) => state.trading.TOKEN);
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  const { bannedTimeout } = useContext(CoinContext);

  // const rows = [
  //   {
  //     currency: "BAT",
  //     available: "1.23",
  //     lastTradedPrice: "1000",
  //     change: "100.00% ↑",
  //   },
  //   {
  //     currency: "BNB",
  //     available: "10.23",
  //     lastTradedPrice: "100",
  //     change: "90.00% ↑",
  //   },
  // ];

  const [coinsConfig, setCoinsConfig] = useState(null);
  const [allBalances, setAllBalances] = useState(null);
  const [iconList, setIconList] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [dynamicList, setDynamicList] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({ title: "", content: "" });
  const [openPaused, setIsOpenPaused] = useState(false);
  const handleClickOpen = (message) => {
    setMessage(message);
    setOpen(true);
  };

  const handleClickPaused = (message) => {
    setMessage(message);
    setIsOpenPaused(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClosePaused = () => {
    setIsOpenPaused(false);
  };

  const fetchCoinConfig = (e) => {
    return fetcher(`/v1/coinConfig`);
  };

  useEffect(() => {
    if (token) {
      fetcher(`/v1/balances`)
        .then(async (data) => {
          // console.log(data);
          if (data !== undefined && data !== null && !data.status) {
            var balanceDict = {};
            data.map((item) => {
              balanceDict[item.coinId] = item;
            });
            setAllBalances(balanceDict);
            const icons = await fetchCoinConfig();
            icons.sort((a, b) => {
              if (balanceDict[a.coinId]) {
                if (Number(balanceDict[a.coinId].availableBalance) === 0)
                  return 1; //Return 1 so that b goes first
              } else {
                return 1; //Return 1 so that b goes first
              }
              if (balanceDict[b.coinId]) {
                if (Number(balanceDict[b.coinId].availableBalance) === 0)
                  return -1; //Return -1 so that a goes first
              } else {
                return -1; //Return -1 so that a goes first
              }
            });

            setIconList(icons);
            setDynamicList(icons);
          }
        })
        .catch((err) => {
          console.error(err);
        });

      // console.log("Getting all balances");
      // console.log(dynamicList);
    }
  }, []);

  useEffect(() => {
    fetcher(`/v1/coinConfig`)
      .then((data) => {
        if (!data.status) {
          var configDict = {};
          data.map((item, i) => {
            configDict[item.coinId] = item;
          });
          setCoinsConfig(configDict);
        }
        // console.log(configDict);
      })
      .catch((err) => {
        // console.error(err);
      });
  }, []);
  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchText(val);

    if (iconList) {
      console.log(iconList, "list");
      if (val !== "") {
        const searchedList = iconList.filter(function (item) {
          return (
            item.coinId.toLowerCase().search(val.toLowerCase()) !== -1 ||
            item.coinName.toLowerCase().search(val.toLowerCase()) !== -1
          );
        });
        // setFilteredData(searchedList);
        setDynamicList(searchedList);
      } else {
        setDynamicList(iconList);
      }
    }
  };

  const userConfig = useQuery(["userconfig"], async () => {
    return await fetcher("/v1/userConfigs");
  });
  console.log(userConfig, "userconfig");
  return (
    <div className={classes.container}>
      <Typography
        style={{ marginBottom: "20px", fontSize: "40px", fontWeight: "bold" }}
      >
        Crypto Wallet
      </Typography>

      <div className={classes.gridContainer}>
        <div
          style={{
            paddingTop: "20px",
            paddingBottom: "20px",
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          <TabSearchbar value={searchText} onChange={handleSearch} />
        </div>

        <div className={classes.tableRoot}>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" className={classes.tableHeader}>
                    Assets
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeader}>
                    Available
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeader}>
                    In Order
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeader}>
                    In Vault
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeader}>
                    Total
                  </TableCell>
                  <TableCell align="left" className={classes.tableHeader}>
                    Trade&nbsp;&nbsp;&nbsp;Send&nbsp;&nbsp;&nbsp;Receive
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dynamicList && coinsConfig
                  ? dynamicList.map((row) => (
                      <TableRow key={row.coinId}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ width: "300px" }}
                        >
                          <div style={{ display: "flex" }}>
                            {/* <Avatar alt="iconImage" src={row.logo} /> */}
                            {/* <Icon
                              icon={row.coinId.toLowerCase()}
                              size={35}
                              color={row.color}
                            /> */}
                            <img
                              src={row.activeIconUrl}
                              height="auto"
                              width={30}
                              className="mr-2"
                              alt={row.coinId}
                            />
                            <div style={{ marginLeft: "5px" }}>
                              <p
                                style={{
                                  fontSize: "16px",
                                  marginTop: 0,
                                  marginLeft: "5px",
                                  marginBottom: 0,
                                }}
                              >
                                {row?.coinName}
                              </p>
                              <p
                                style={{
                                  color: "#9fa1a0",
                                  marginBottom: 0,
                                  marginTop: 0,
                                  marginLeft: "5px",
                                }}
                              >
                                {row.coinId}
                              </p>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align="left" style={{ width: "220px" }}>
                          {allBalances[row.coinId]
                            ? Number(allBalances[row.coinId].availableBalance)
                            : 0}
                        </TableCell>
                        <TableCell align="left" style={{ width: "220px" }}>
                          {allBalances[row.coinId]
                            ? Number(allBalances[row.coinId].inOrderBalance)
                            : 0}
                        </TableCell>
                        <TableCell align="left" style={{ width: "220px" }}>
                          {allBalances[row.coinId]
                            ? Number(allBalances[row.coinId].inVaultBalance)
                            : 0}
                        </TableCell>
                        <TableCell align="left" style={{ width: "300px" }}>
                          {allBalances[row.coinId]
                            ? coinsConfig[row.coinId]
                              ? Number(
                                  (
                                    Number(
                                      allBalances[row.coinId].availableBalance
                                    ) +
                                    Number(
                                      allBalances[row.coinId].inOrderBalance
                                    )
                                  ).toFixed(
                                    coinsConfig[row.coinId].decimalWithdraw
                                  )
                                )
                              : Number(
                                  Number(
                                    allBalances[row.coinId].availableBalance
                                  ) +
                                    Number(
                                      allBalances[row.coinId].inOrderBalance
                                    )
                                )
                            : 0}
                        </TableCell>
                        <TableCell align="left">
                          <Box display="flex">
                            <IconButton
                              onClick={() => {
                                if (coinsConfig) {
                                  if (coinsConfig[row.coinId]) {
                                    if (userConfig.data) {
                                      console.log("outside");
                                      if (
                                        coinsConfig[row.coinId]?.tradeStatus ==
                                          "ACTIVE" &&
                                        userConfig.data?.ct
                                      ) {
                                        history.push(`/trade/${row.coinId}`);
                                      } else {
                                        (coinsConfig[row.coinId].tradeStatus ===
                                          "PAUSED" ||
                                          coinsConfig[row.coinId]
                                            .tradeStatus === "INACTIVE") &&
                                        userConfig.data?.ct
                                          ? handleClickPaused({
                                              title:
                                                coinsConfig[row.coinId]
                                                  .tradeStatus === "PAUSED"
                                                  ? "Trades Paused"
                                                  : "Trades Disabled",
                                              content:
                                                coinsConfig[row.coinId]
                                                  .tradeStatus === "PAUSED"
                                                  ? `Trades for ${row.coinId} are temporarily on hold. Please check back later.`
                                                  : `Trades for ${row.coinId} are disabled.`,
                                            })
                                          : handleClickOpen({
                                              title: "Trades are Disabled",

                                              content:
                                                "Trades are disabled on your account, kindly contact support for more details",
                                            });
                                      }
                                    }
                                  }
                                }
                              }}
                              style={{
                                color: coinsConfig
                                  ? coinsConfig[row.coinId]
                                    ? userConfig.data
                                      ? coinsConfig[row.coinId]?.tradeStatus ==
                                          "ACTIVE" && userConfig.data?.ct
                                        ? theme.palette.type === "dark"
                                          ? "#c5c5c5"
                                          : "#7b7b7b"
                                        : "#7B7B7B"
                                      : null
                                    : null
                                  : null,
                              }}
                            >
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "12px" }}>
                                    Trade
                                  </span>
                                }
                                placement="left"
                              >
                                <span style={{ width: "24px", height: "24px" }}>
                                  <ImportExportIcon />
                                </span>
                              </Tooltip>
                            </IconButton>

                            <IconButton
                              onClick={() => {
                                if (coinsConfig) {
                                  if (coinsConfig[row.coinId]) {
                                    if (userConfig.data) {
                                      if (
                                        coinsConfig[row.coinId]
                                          ?.withdrawStatus == "ACTIVE" &&
                                        userConfig.data?.cw
                                      ) {
                                        history.push(
                                          `/wallet/crypto/withdraw?coin=${row.coinId}`
                                        );
                                      } else {
                                        (coinsConfig[row.coinId]
                                          .withdrawStatus === "PAUSED" ||
                                          coinsConfig[row.coinId]
                                            .withdrawStatus === "INACTIVE") &&
                                        userConfig.data?.cw
                                          ? handleClickPaused({
                                              title:
                                                coinsConfig[row.coinId]
                                                  .withdrawStatus === "PAUSED"
                                                  ? "Withdrawals Paused"
                                                  : "Withdrawals Disabled",
                                              content:
                                                coinsConfig[row.coinId]
                                                  .withdrawStatus === "PAUSED"
                                                  ? `Withdrawals for ${row.coinId} are temporarily on hold. Please check back later.`
                                                  : `Withdrawals for ${row.coinId} are disabled.`,
                                            })
                                          : handleClickOpen({
                                              title:
                                                "Sending Crypto to other wallets is paused",

                                              content:
                                                "Crypto Transfers to other wallets/exchanges have been temporarily paused while we seek regulatory clarity on compliance requirements from the relevant authorities.",
                                              note: "Kindly note that INR transfers are available on the INR wallet page.",
                                            });
                                      }
                                    }
                                  }
                                }
                              }}
                              style={{
                                color: coinsConfig
                                  ? coinsConfig[row.coinId]
                                    ? userConfig.data
                                      ? coinsConfig[row.coinId]
                                          ?.withdrawStatus == "ACTIVE" &&
                                        userConfig.data?.cw
                                        ? theme.palette.type === "dark"
                                          ? "#c5c5c5"
                                          : "#7b7b7b"
                                        : "#7b7b7b"
                                      : null
                                    : null
                                  : null,
                              }}
                            >
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "12px" }}>Send</span>
                                }
                                placement="left-start"
                              >
                                <span style={{ width: "24px", height: "24px" }}>
                                  <FiSend />
                                </span>
                              </Tooltip>
                            </IconButton>

                            <IconButton
                              onClick={() => {
                                if (coinsConfig) {
                                  if (coinsConfig[row.coinId]) {
                                    if (userConfig.data) {
                                      if (
                                        coinsConfig[row.coinId]
                                          ?.depositStatus == "ACTIVE" &&
                                        userConfig.data?.cd
                                      ) {
                                        history.push(
                                          `/wallet/crypto/deposit?coin=${row.coinId}`
                                        );
                                      } else {
                                        (coinsConfig[row.coinId]
                                          .depositStatus === "PAUSED" ||
                                          coinsConfig[row.coinId]
                                            .depositStatus === "INACTIVE") &&
                                        userConfig.data?.cd
                                          ? handleClickPaused({
                                              title:
                                                coinsConfig[row.coinId]
                                                  .depositStatus === "PAUSED"
                                                  ? "Deposits Paused"
                                                  : "Deposits Disabled",
                                              content:
                                                coinsConfig[row.coinId]
                                                  .depositStatus === "PAUSED"
                                                  ? `Deposits for ${row.coinId} are temporarily on hold. Please check back later.`
                                                  : `Deposits for ${row.coinId} are disabled.`,
                                            })
                                          : handleClickOpen({
                                              title:
                                                "Receiving Crypto from other wallets is paused.",

                                              content:
                                                "Crypto Transfers from other wallets/exchanges have been temporarily paused while we seek regulatory clarity on compliance requirements from the relevant authorities.",
                                              note: "Kindly note that INR transfers are available on the INR wallet page.",
                                            });
                                      }
                                    }
                                  }
                                }
                              }}
                              style={{
                                marginLeft: "20px",
                                color: coinsConfig
                                  ? coinsConfig[row.coinId]
                                    ? userConfig.data
                                      ? coinsConfig[row.coinId]
                                          ?.depositStatus == "ACTIVE" &&
                                        userConfig.data?.cd
                                        ? theme.palette.type === "dark"
                                          ? "#c5c5c5"
                                          : "#7b7b7b"
                                        : "#7b7b7b"
                                      : null
                                    : null
                                  : null,
                              }}
                              // disabled={
                              //   coinsConfig
                              //     ? coinsConfig[row.coinId]
                              //       ? !coinsConfig[row.coinId].depositAllowed
                              //       : true
                              //     : true
                              // }
                            >
                              <Tooltip
                                title={
                                  <span
                                    style={{
                                      fontSize: "12px",
                                    }}
                                  >
                                    Receive
                                  </span>
                                }
                                placement="right"
                              >
                                <span
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                  }}
                                >
                                  <BsArrowDown />
                                </span>
                              </Tooltip>
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              ...(!isFirefox && {
                background: darkMode
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(0, 0, 0, 0.3)",
                backdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
                WebkitBackdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
                borderRadius: "16px",
              }),
            },
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            className="text-lg w-[400px]  max-w-[400px]  font-medium text-[#36BCA2]"
            id="alert-dialog-title"
          >
            {message.title}
          </DialogTitle>
          <DialogContent className="w-[400px] h-[250px]  max-w-[400px]">
            <DialogContentText
              className="text-base font-normal leading-8"
              id="alert-dialog-description"
            >
              {message.content}
            </DialogContentText>

            <DialogContentText
              className="text-base font-normal leading-8"
              id="alert-dialog-description"
            >
              {message.note}
            </DialogContentText>
          </DialogContent>
          <DialogActions className="flex justify-center">
            <Button
              onClick={handleClose}
              color="primary"
              variant="contained"
              style={{
                color: "white",
                fontWeight: "bold",
                marginRight: "17px",
                marginBottom: "12px",
              }}
              className="w-[197px] rounded-sm h-[37px]"
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>
        <CryptoWalletDialog
          open={openPaused}
          message={message}
          handleClickOpen={handleClickPaused}
          handleClose={handleClosePaused}
        />
      </div>

      <Backdrop
        className={classes.backdrop}
        open={dynamicList && coinsConfig ? false : true}
      >
        {/* <CircularProgress color="primary" /> */}
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down("sm")]: {
      // minWidth: "450px",
      maxWidth: "450px",
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "95%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    // marginTop: "20px",
    // padding: "20px",
    // [theme.breakpoints.up("md")]: {
    //   marginRight: "50px",
    // },
  },
  boxStyle: {
    backgroundColor: theme.palette.type === "dark" ? "#424948" : "#eee",
    // minWidth: '300px',
    maxWidth: "450px",
    border:
      theme.palette.type === "dark" ? "1px solid #424948" : "1px solid #eee",
    borderRadius: "5px",
    paddingLeft: "15px",
    paddingRight: "15px",
    marginBottom: "15px",
  },
  iconSize: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  ptitle: {
    margin: 0,
    marginTop: "8px",
    color: "#9fa1a0",
  },
  pvalue: {
    margin: 0,
    marginBottom: "10px",
  },
  depositButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "8px",
      marginRight: "20px",
      fontSize: "16px",
      paddingTop: "8px",
      paddingRight: "32px",
      paddingBottom: "8px",
      paddingLeft: "32px",
    },
    color: "white",
    fontWeight: "bold",
  },
  withdrawButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "8px",
      fontSize: "16px",
      paddingTop: "8px",
      paddingRight: "32px",
      paddingBottom: "8px",
      paddingLeft: "32px",
    },
    fontWeight: "bold",
  },
  amount: {
    margin: 0,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "26px",
    },
  },
  tableHeader: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  tableRoot: {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      "&:after": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        top: "0",
        right: "0",
        bottom: "15px",
        pointerEvents: "none",
        backgroundImage:
          theme.palette.type === "dark"
            ? "linear-gradient(to right,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1))"
            : "linear-gradient(to right, rgba(255, 255, 255, 0), #999 85%)",
        width: "15%",
      },
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default CryptoWallet;
